import { Container } from "@material-ui/core";
import Fab from "@material-ui/core/Fab";
import Hidden from "@material-ui/core/Hidden";
import { makeStyles } from "@material-ui/core/styles";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import Footer from "components/common/Footer";
import Header from "components/common/Header";
import ScrollTop from "components/common/ScrollTop";
import SidebarLeft from "components/common/SidebarLeft";
import { drawerWidth } from "libs/configs/constant";
import { USER_ROLE } from "libs/constant/role";
import useAuth from "libs/hooks/useAuth";
import React from "react";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  layout: {
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    backgroundColor: theme.palette.background.main,
    [theme.breakpoints.up("lg")]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
  },
  main: {
    backgroundColor: theme.palette.background.default,
    display: "flex",
    flex: 1,
    flexGrow: 1,
  },
  container: {
    paddingBottom: theme.spacing(3),
    // paddingLeft: 0,
    // paddingRight: 0,
    // backgroundColor: "pink",
  },
}));

export default function Layout({ children, title = "" }) {
  const classes = useStyles();
  const history = useHistory();
  const { userRole } = useAuth();
  const [isOpenDrawer, setOpenDrawer] = React.useState(false);

  const handleDrawerToggle = () => {
    setOpenDrawer(!isOpenDrawer);
  };

  const handleOnClickLogo = () => {
    if ([USER_ROLE.AGENT].includes(userRole)) {
      history.push("/select-role");
    } else {
      history.push("/");
    }
  };

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <div className={classes.layout}>
      <Header
        onClickLogo={handleOnClickLogo}
        onClickHamberger={handleDrawerToggle}
      />
      <Hidden mdUp implementation="css">
        <SidebarLeft
          variant="temporary"
          open={isOpenDrawer}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
        />
      </Hidden>
      <Hidden mdDown implementation="css">
        <SidebarLeft container={container} variant="permanent" open />
      </Hidden>
      <main className={classes.main}>
        <Container maxWidth="lg" className={classes.container}>
          {children}
        </Container>
      </main>
      <Footer />
      <ScrollTop>
        <Fab color="secondary" size="small" aria-label="scroll back to top">
          <KeyboardArrowUpIcon />
        </Fab>
      </ScrollTop>
    </div>
  );
}
